import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Distributor, DistributorsService } from 'core/index';
import { BrokerCreditsDealerService } from '../broker-credits-dealer.service';

@Component({
  selector: 'lms-broker-credits-management',
  templateUrl: './broker-credits-management.component.html',
  styleUrls: ['./broker-credits-management.component.scss']
})
export class BrokerCreditsManagementComponent implements OnInit {
  public distributor: Distributor;
  public distributorCreditsPurchasesListId = 'DISTRIBUTOR_CREDITS_PURCHASES_LIST';
  public distributorCreditsSaleslistId = 'DISTRIBUTOR_CREDITS_SALES_LIST';

  constructor(
    public dealerService: BrokerCreditsDealerService,
    public route: ActivatedRoute,
    public distributorsService: DistributorsService
  ) {}

  ngOnInit() {
    this.route.data.subscribe((data) => {
      this.distributor = data['distributor'];
    });
  }

  onUpdateDistributor(distributor: Distributor) {
    this.distributor = distributor;
  }

  onTransactionCompleted() {
    this.distributorsService.getDistributor(this.distributor.id).subscribe((distributor) => {
      this.onUpdateDistributor(distributor);
    });
  }
}
